import twitterLogo from '../assets/images/platforms/twitter-logo.png'
import youtubeLogo from '../assets/images/platforms/youtube-logo.png'
import linkedinLogo from '../assets/images/platforms/linkedin-logo.png'
import facebookLogo from '../assets/images/platforms/facebook-logo.png'
import instagramLogo from '../assets/images/platforms/instagram-logo.png'
import redditLogo from '../assets/images/platforms/reddit-logo.png'
import vimeoLogo from '../assets/images/platforms/vimeo-log.png'
import pinterestLogo from '../assets/images/platforms/pinterest-log.png'
import mediumLogo from '../assets/images/platforms/medium-logo.png'
import tumblrLogo from '../assets/images/platforms/tumblr-logo.png'
import soundcloudLogo from '../assets/images/platforms/soundcloud-logo.png'
import shazamLogo from '../assets/images/platforms/shazam-logo.png'
import spotifyLogo from '../assets/images/platforms/spotify-logo.png'
import steemitLogo from '../assets/images/platforms/steemit-logo.png'
import googleNewsLogo from '../assets/images/platforms/google-news-logo.png'

export const logos = {
    Twitter: twitterLogo,
    YouTube: youtubeLogo,
    LinkedIn: linkedinLogo,
    Facebook: facebookLogo,
    Instagram: instagramLogo,
    Reddit: redditLogo,
    Vimeo: vimeoLogo,
    Pinterest: pinterestLogo,
    Medium: mediumLogo,
    Tumblr: tumblrLogo,
    SoundCloud: soundcloudLogo,
    Shazam: shazamLogo,
    Spotify: spotifyLogo,
    Steemit: steemitLogo,
    'Google News': googleNewsLogo,
}
